import {
  ADMIN_DASHBOARD,
  ADMIN_HOME_PATH,
  AUTOMATION_ROUTE,
  AUTOMATION_ROUTE_V2,
  COMMON_HOME,
  PRICING_ROUTE,
  PRODUCT_BUILDER_ROUTE,
  REQUESTS_ROUTE,
  RETAIL_AUTOMATION_ROUTE,
  RETAIL_AUTOMATION_ROUTE_V2,
  SLA_AGREEMENT_ROUTE,
} from '../constants/routePathConstants';
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom';
import {
  MAIN_MENU,
  SIDEBAR_MENU,
  SIDEBAR_MENU_2,
  SIDEBAR_MENU_3,
  SIDEBAR_MENU_V2,
  GUEST_USER_SIDEBAR_MENU,
} from '../constants/menu';
import { Mixpanel, MxEvent } from '../common/Mixpanel';
import { Nav, Navbar, Overlay, Tooltip } from 'react-bootstrap';
import {
  addUpdateParamsInSequence,
  filterActions,
  filterSelector,
  removeParamsInSequence,
  resetMembers,
  resetParamsInSequence,
  selectParamsInSequence,
  setMembers,
} from '../redux/slicers/filters/filterSlicer';
import {
  changeSideFilter,
  resetFilters,
  selectFilterModalStatus,
  selectFilterTeamInModalStatus,
  selectMaxVisibleFilterOptions,
  setClickedSidefilterType,
  setDoFilterUpdateValue,
  setFilterModalStatus,
} from '../redux/slicers/admin/sidebarSlicer';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ADMIN_MY_PRODUCTS_3DMODAL_V2 } from '../constants/routePathConstants';
import { ADMIN_MY_PROPS_V2, SETTINGS_ROUTE } from '../config/constant/routePathConstant';
import Button from '../components/Button';
import Close from '../assets/images/close.png';
import { FILTER } from '../components/admin/curator/CuratorFilter/CuratorFilter';
import { FilterContext } from '../contexts';
import { RightSidebar } from '../common';
import SearchInput from '../common/SearchInput';
import { SideFilter } from '../components/SideFilter/SideFilter';
import _ from 'lodash';
import cx from 'classnames';
import { errorToast } from '../helpers/toastHelper';
import { getUpdatedValueFromFiltersValue } from '../helpers/urlHelper';
import { selectHasAutomationsData } from '../redux/slicers/subscriptionSlicer';
import { selectSearchActive } from '../redux/slicers/search/searchSlicer';
import {
  setContactSupportFormOpen,
  setFeedbackDialogOpen,
  setUploadedFiles,
} from '../redux/slicers/appSlicer';
import { showHideTooltip } from '../components/gamificationTooltip/helpers';
import styles from '../components/SideFilter/FilterItem.module.scss';
import { useCheckCuratorActive } from '../hooks/useCuratorActive';
import { useGlobalFilters } from '../hooks/useGlobalFilters';
import { useMattressBuilderPermission } from '../components/admin/curator/ProductBuilderComponents/useMattressBuilderPermission';
import { useMembersV4 } from '../hooks/useMembers';
import { usePrevious } from 'react-use';
import { useStaticPermissions } from '../hooks/usePermissions';
import { useUserContext } from '../contexts/UserContext';
import {
  YouAreOnFreemium,
  YouAreOnPackSubscription,
} from '../screens/subscriptionComponents/FloatingCardUI';
import {
  IMAGINE_DISCORD_CHANNEL,
  IMAGINE_INSTAGRAM_CHANNEL,
  MENU_TYPE,
} from '../constants/constants';
import { setSignupPopOpen, setSignupPopOpenedFrom } from '../redux/slicers/uiSlicer';
import useCurrentOrganizationInfo from '../hooks/useCurrentOrganizationInfo';
import { apiGetTeamMembersV4 } from '../helpers/api';
import { MODE, useApiList } from '../hooks/useApiList';
import { updatePositionHubSpotChatIcon } from '../helpers/jsHelper';
import { Requests_Label } from '../constants/filters';
import { navigate } from '../helpers/projectHelper';
import Lottie from 'lottie-react';

export default function Sidemenu(props) {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const filterCtx = useContext(FilterContext);
  const location = useLocation();
  const prevPathname = usePrevious(location.pathname);
  const searchActive = useSelector(selectSearchActive);
  const paramsInSequence = useSelector(selectParamsInSequence);
  const showModalFilter = useSelector(selectFilterModalStatus);
  const showModalTeamInFilter = useSelector(selectFilterTeamInModalStatus);
  const maxVisibleFilterOptions = useSelector(selectMaxVisibleFilterOptions);
  const { currentUser, isGuestUser, isGuestLogin, canUseWorkflowBuilder } = useUserContext();
  const { hideNewPlans } = useCurrentOrganizationInfo();
  const { hasPermission } = useStaticPermissions();
  const hasAutomationData = useSelector(selectHasAutomationsData);
  const { permission: hasMattressBuilderPermission } = useMattressBuilderPermission();
  const selectedMembers = useSelector((state) => filterSelector(state).members);
  const [searchInput, setSearchInput] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);

  const requestParams = useMemo(
    () => ({
      perPage: 50,
    }),
    []
  );

  const { list: memberList, refetchAllData } = isGuestUser()
    ? { list: [] }
    : useApiList({
        api: apiGetTeamMembersV4,
        mode: MODE.PARAMS,
        defaultPerPage: 20,
        params: {
          ...requestParams,
        },
        fetchAll: true,
      });

  useEffect(() => {
    if (memberList?.length) {
      refetchAllData();
    }
  }, [currentUser?.organization]);

  useEffect(() => {
    if (!prevPathname) return;
    const { pathname } = location;

    const p1 = pathname.split('/')[1];
    const p2 = prevPathname.split('/')[1];

    if (p1 === p2) return; // we don't want to reset filters when it was inside of same route

    dispatch(resetFilters({ syncQuery: false }));
    dispatch(resetMembers());
    dispatch(filterActions.setFilterByFromSearchQuery(null));
  }, [location.pathname, dispatch]);

  useEffect(() => {
    updatePositionHubSpotChatIcon(
      Boolean(showModalFilter),
      'update-position-hubSpot-chat-icon-filter-sidebar'
    );
  }, [showModalFilter]);

  const { filters, filterValues, filtersLoading } = useGlobalFilters();

  const handleGetTeamList = () => {
    let lists = [];
    memberList?.map((list) => {
      lists.push({
        all: list,
        type: 'team',
        label: list?.user?.name || list?.user?.first_name,
        value: `member_id_${list?.id}`,
        checked: selectedMembers?.some(({ id }) => +id === list?.id),
      });
    });
    return lists;
  };

  const propFilters =
    location.pathname === ADMIN_MY_PROPS_V2 || location.pathname === ADMIN_MY_PRODUCTS_3DMODAL_V2
      ? [
          { label: 'Product Group', value: FILTER.GROUP_PROP },
          { label: 'User Model', value: FILTER.USER_MODEL_UPLOADED },
          // { label: 'All User Props', value: FILTER.ALL_USER_PROPS },
        ]
      : [];
  const archiveFilter =
    location.pathname === AUTOMATION_ROUTE || location.pathname === AUTOMATION_ROUTE_V2
      ? [{ label: 'Archived', value: 'archive' }]
      : [];
  // Retail automations can't be favourited - their cards hide the heart - so the
  // filter would only ever return an empty list.
  const favouriteFilter =
    !isGuestUser() &&
    location.pathname !== RETAIL_AUTOMATION_ROUTE &&
    location.pathname !== RETAIL_AUTOMATION_ROUTE_V2
      ? [{ label: 'My favorites', value: 'favourite' }]
      : [];
  const teamFilter = showModalTeamInFilter ? [{ title: 'Team', items: handleGetTeamList() }] : [];
  const meChecbox =
    showModalTeamInFilter && !isGuestUser()
      ? [
          {
            label: 'Me',
            value: `member_id_${currentUser.id}`,
            all: {
              name: currentUser.name,
              id: currentUser.id,
              avatar: currentUser.profile_image,
            },
            checked: selectedMembers?.some(({ id }) => +id === +currentUser.id),
            type: 'me',
          },
        ]
      : [];
  const updatedFilters = [
    {
      items: [
        ...favouriteFilter,
        ...meChecbox,
        ...propFilters,
        ...archiveFilter,
      ],
    },
    ...teamFilter,
    ...filters,
  ];

  const handleFilterChange = (value) => {
    if (value.match('member_id')?.length) {
      const memberId = value?.replace('member_id_', '');
      const newValue = selectedMembers.find((m) => +m.id === +memberId)
        ? selectedMembers.filter((m) => m.id !== +memberId)
        : [...selectedMembers, { id: +memberId }];
      if (!newValue?.length) {
        dispatch(resetMembers());
        dispatch(removeParamsInSequence('created_by'));
        dispatch(changeSideFilter());
        return;
      }
      dispatch(setMembers(newValue));
    } else if (value === 'favourite') {
      const i = paramsInSequence.findIndex((a) => Object.keys(a)[0] === 'is_favourite');
      if (i === -1) {
        const activeFav = searchParams.get('is_favourite');
        dispatch(removeParamsInSequence('filterOrder'));
        if (!activeFav) {
          dispatch(addUpdateParamsInSequence({ ['is_favourite']: true }));
        }
      } else {
        dispatch(removeParamsInSequence('is_favourite'));
      }
    } else if (value === FILTER.GROUP_PROP) {
      const i = paramsInSequence.findIndex((a) => Object.keys(a)[0] === 'is_prop_group');
      if (i === -1) {
        Mixpanel.track(true, MxEvent.PG_FILTER);
        dispatch(addUpdateParamsInSequence({ ['is_prop_group']: true }));
      } else {
        dispatch(removeParamsInSequence('is_prop_group'));
      }
    } else if (value === FILTER.USER_MODEL_UPLOADED) {
      const i = paramsInSequence.findIndex((a) => Object.keys(a)[0] === 'is_user_model_uploaded');
      if (i === -1) {
        dispatch(addUpdateParamsInSequence({ ['is_user_model_uploaded']: true }));
      } else {
        dispatch(removeParamsInSequence('is_user_model_uploaded'));
      }
    } else if (value === FILTER.ALL_USER_PROPS) {
      const i = paramsInSequence.findIndex((a) => Object.keys(a)[0] === 'assign_to_all_org');
      if (i === -1) {
        dispatch(addUpdateParamsInSequence({ ['assign_to_all_org']: true }));
      } else {
        dispatch(removeParamsInSequence('assign_to_all_org'));
      }
    } else if (value === FILTER.MATTRESS_BUILDER) {
      const i = paramsInSequence.findIndex((a) => Object.keys(a)[0] === 'is_mattress_material');
      if (i === -1) {
        dispatch(addUpdateParamsInSequence({ ['is_mattress_material']: true }));
      } else {
        dispatch(removeParamsInSequence('is_mattress_material'));
      }
    } else if (value === 'archive') {
      const i = paramsInSequence.findIndex((a) => Object.keys(a)[0] === 'is_archive');
      if (i === -1) {
        dispatch(addUpdateParamsInSequence({ ['is_archive']: true }));
      } else {
        dispatch(removeParamsInSequence('is_archive'));
      }
    } else {
      const { key, updatedVal } = getUpdatedValueFromFiltersValue(value, paramsInSequence);

      if (!updatedVal.length) {
        dispatch(removeParamsInSequence(key));
      } else {
        dispatch(addUpdateParamsInSequence({ [key]: updatedVal }));
        dispatch(setClickedSidefilterType(value));
      }
    }
    if (!value.match('member_id')?.length) {
      dispatch(changeSideFilter(value));
    }
    dispatch(setDoFilterUpdateValue(true));
  };

  // const UPDATED_MAIN_MENU = useMemo(() => {
  //   return [
  //     ...MAIN_MENU.map((a) => {
  //       if (a?.path === AUTOMATION_ROUTE) {
  //         if (hasAutomationData) return a;
  //         else if (a?.permission && hasPermission(a?.permission)) return a;
  //         else return false;
  //       }
  //       if (a?.permission && !hasPermission(a?.permission)) return false;

  //       return a;
  //     }).filter(Boolean),
  //   ];
  // }, [hasAutomationData, currentUser?.organization, currentUser?.permissions_list]);

  const UPDATED_MAIN_MENU_V2 = useMemo(() => {
    const MENU = isGuestLogin
      ? GUEST_USER_SIDEBAR_MENU
      : isGuestUser()
      ? SIDEBAR_MENU_V2.filter((a) => a?.canGuestUserAccess)
      : SIDEBAR_MENU_V2;
    return [
      ...MENU.map((a) => {
        let childPath = [];
        if (a?.isChild && a?.hoverChildMenu?.length > 0) {
          a?.hoverChildMenu?.map((child) => {
            if (
              ((child.path === AUTOMATION_ROUTE || child.path === AUTOMATION_ROUTE_V2) &&
                hasAutomationData) ||
              (child?.permission && hasPermission(child.permission)) ||
              !child?.permission
            ) {
              childPath.push(child);
            }
          });
        }
        if (childPath?.length) {
          a.hoverChildMenu = childPath;
        }
        if (a.permission && !hasPermission(a.permission)) return null;
        if (a?.requiresCanUseWorkflowBuilder && !canUseWorkflowBuilder) return null;
        if (a.path === PRODUCT_BUILDER_ROUTE && !hasMattressBuilderPermission) return null;
        return a;
      }).filter(Boolean),
    ];
  }, [
    hasAutomationData,
    hasMattressBuilderPermission,
    canUseWorkflowBuilder,
    currentUser?.organization,
    currentUser?.permissions_list,
  ]);

  const onClose = () => {
    dispatch(setFilterModalStatus(false));
    if (!filterValues?.length) {
      setSearchInput('');
      searchInput && dispatch(resetFilters());
    }
    dispatch(filterActions.setFilterSearchValue(''));
    window.$restrictFilter = null;
  };

  const handleClearAllFilter = (closeModal = true) => {
    window.$restrictFilter = null;
    dispatch(removeParamsInSequence('created_by'));
    dispatch(resetParamsInSequence('sidebarfilter'));
    dispatch(removeParamsInSequence('is_user_model_uploaded'));
    if (closeModal) {
      dispatch(resetFilters());
      dispatch(resetMembers());
      dispatch(setFilterModalStatus(false));
      setSearchInput('');
      dispatch(filterActions.setFilterSearchValue(''));
    }
  };

  const onSearchChange = (value) => {
    setSearchInput(value?.target?.value);
    dispatch(filterActions.setFilterSearchValue(value?.target?.value));
  };

  const handleFilterValueBySearch = () => {
    let filterValue = [];
    if (searchInput) {
      updatedFilters?.map((list) => {
        let fillterData = { ...list };
        let items = [];
        // if we have the team filter then we are doing the search in the frontend only
        // and, updating the items for that only
        if (fillterData?.title?.toLowerCase() === 'team') {
          fillterData?.items?.map((item) => {
            if (item?.label?.toLowerCase()?.search(searchInput?.toLowerCase()) !== -1) {
              items.push(item);
            }
          });
          fillterData.items = items;
        }
        if (fillterData.items?.length) {
          filterValue.push(fillterData);
        }
      });
      return hideFilterSection(filterValue) || [];
    } else {
      updatedFilters?.map((list) => {
        if (list.items?.length) {
          filterValue.push(list);
        }
      });
      return hideFilterSection(filterValue) || [];
    }
  };

  if (filterCtx?.hideSidemenu && !searchActive) return null;
  const showFilter = filterCtx?.showDrilldownMenu || searchActive;

  const hideFilterSection = (value) => {
    if (window.location.pathname === ADMIN_MY_PROPS_V2) {
      const hideSectionName = ['room scene', 'sub category', 'sub categories'];
      const filterValue = value?.filter(
        ({ title }) => !title || !hideSectionName?.includes(title?.trim?.()?.toLowerCase?.())
      );
      return filterValue;
    } else {
      return value;
    }
  };

  return (
    <aside className={`sidebar ${props?.showMenu ? 'show-menu' : ''}`}>
      <div className={cx('sidebar-wrapper filter-sidebar-wrapper')}>
        <div className={cx('sidebar-filter fs-container filter_container')}>
          {/* <button onClick={onClose}>open Filter</button> */}
          {showModalFilter && (
            <RightSidebar
              backdropClassName=""
              className={`rightSidebar props designV2`}
              initialShowOpen={Boolean(showModalFilter)}
              onClose={onClose}
              designV2
              title={
                <>
                  <div className="heading-user-title">
                    <h4 className="m-0 ellipsis">Filters</h4>
                  </div>
                </>
              }
              body={
                <>
                  <div className={`${styles.filterForm} filter-form`}>
                    {showFilter && (
                      <>
                        <SearchInput
                          loading={searchLoading}
                          value={searchInput || ''}
                          placeholder="Search"
                          onChange={onSearchChange}
                          onClear={() => {
                            setSearchInput('');
                            dispatch(filterActions.setFilterSearchValue(''));
                          }}
                        />
                        <SideFilter
                          setSearchLoading={setSearchLoading}
                          filters={handleFilterValueBySearch()}
                          onChange={handleFilterChange}
                          value={filterValues}
                          designV2
                          maxVisible={maxVisibleFilterOptions}
                          handleClearAllFilter={handleClearAllFilter}
                        />
                        <div className="filter-btn">
                          <Button
                            variant="outline"
                            color="secondary"
                            onClick={handleClearAllFilter}>
                            Clear All
                          </Button>
                          <Button variant="outline-secondary" onClick={onClose}>
                            View
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              }
            />
          )}
          <div className="d-flex flex-column justify-content-between w-100 h-100">
            <div className="feature-nav mt-0 mb-5 pb-2">
              <CommonFeatureMenu navList={UPDATED_MAIN_MENU_V2} />
            </div>
            <div className="feature-nav mt-auto">
              {!isGuestLogin && !hideNewPlans && (
                <>
                  <YouAreOnPackSubscription />
                  <YouAreOnFreemium />
                </>
              )}
              <CommonFeatureMenu
                navList={
                  isGuestLogin
                    ? SIDEBAR_MENU_2?.slice(0, SIDEBAR_MENU_2?.length - 1)
                    : SIDEBAR_MENU_2
                }
                showBtn={isGuestLogin}
              />
              {/* <CommonFeatureMenu navList={SIDEBAR_MENU_3} /> */}
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
    </aside>
  );
}
// let childMenuref = [];
export function CommonFeatureMenu({
  navList: _navList,
  className = '',
  menuClassName = '',
  menuItemClassName = '',
  style = {},
  floatingMenu = false,
  showBtn = null,
}) {
  const location = useLocation();
  const URLParams = useParams();
  const dispatch = useDispatch();
  const [tutorialsRef, setTutorialsRef] = useState(null);
  const { currentUser, updateUserData, logout, isGuestUser, isPackOrganization, isGuestLogin } =
    useUserContext();
  const { isFreemiumOrSelfServeUser, isPremiumUser } = useCurrentOrganizationInfo();
  const [tooltip, setTooltip] = useState(false);
  const [showHoverComponent, setShowHoverComponent] = useState(false);
  const showTooltip = currentUser?.user?.other_info?.showTutorialsTooltip || false;
  const [timer, setTimer] = useState(null);
  const { isCuratorActive } = useCheckCuratorActive();

  if (!isPackOrganization) {
    _navList = _navList.filter((a) => a?.path !== SLA_AGREEMENT_ROUTE);
  }

  // TODO: show the contact support menu to those users who have purchase any things from us
  if (!(isPackOrganization || isPremiumUser)) {
    _navList = _navList.filter((a) => a?.key !== MENU_TYPE.CONTACT_SUPPORT_FORM);
  }

  const navList = isGuestUser() ? _navList.filter((a) => a?.canGuestUserAccess) : _navList;

  useEffect(() => {
    if (showTooltip) {
      if (timer) {
        clearTimeout(timer);
      }
      const timeout = setTimeout(() => {
        setTooltip(true);
      }, 500);
      setTimer(timeout);
    } else {
      setTooltip(false);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [showTooltip]);

  // AI Studio is the only menu item that leaves the app, so it is the only one that needs to
  // say which door was used — every other item's `click_from` would just be noise.
  const menuClickProps = (item) =>
    item?.mx_event === MxEvent.CLICKED_AI_STUDIO ? { click_from: 'App Dashboard' } : undefined;

  const hideTooltip = () => {
    const obj = {
      showTutorialsTooltip: false,
    };
    showHideTooltip(currentUser, updateUserData, obj);
    setTooltip(false);
  };

  async function handleLogout() {
    const curatorActive = await isCuratorActive();
    if (curatorActive) {
      errorToast('Please close or save any open project before logging out.');
      return;
    }

    Mixpanel.track(true, MxEvent.LOGIN_OUT_SUCCESS);

    Mixpanel.reset();
    Mixpanel.track(true, MxEvent.VISITED_LOGIN);

    logout();
  }

  const handleDetailsPageRoute = (item) => {
    const keyLists = Object.keys(URLParams);
    const keyName = keyLists?.[0];
    const pathReplaceValue = `:${keyName}`;
    const valueParam = URLParams[keyName];
    let isActive = false;
    if (item?.hoverChildMenu && item?.hoverChildMenu?.length) {
      item?.hoverChildMenu?.map((path) => {
        if (!isActive) {
          if (path.path.includes(pathReplaceValue)) {
            if (location.pathname === path?.path?.replace(pathReplaceValue, valueParam)) {
              isActive = true;
            }
          }
        }
      });
    } else {
      isActive = false;
    }
    return isActive;
  };

  const handleMouseHover = (e, item, _value) => {
    e.preventDefault();
    if (item.hoverComponent) setShowHoverComponent(_value);
  };

  const handleShowModal = () => {
    dispatch(setSignupPopOpen(true));
    dispatch(setSignupPopOpenedFrom('sidemenu'));
  };

  return (
    <>
      <Navbar
        expand="xs"
        className={`sidemenu page-nav flex-column align-items-start ${className}`}
        style={style}>
        <Nav as="ul" className={`menu ${menuClassName}`}>
          {navList.map((item, i) => {
            const Icon = item?.icon;
            const LottieIcon = item?.hasLottie;
            const target = item?.target || '_self';
            const params = new URLSearchParams(location.search);

            //bottom was commented and added directly to the feedback button onClick event.
            // const onClick = () => {
            //   if (item.key === "FEEDBACK") {
            //     dispatch(setFeedbackDialogOpen(true));
            //   }
            // };

            return (
              <Nav.Item
                as="li"
                key={item.path || item.name}
                ref={(elem) => {
                  if (elem && item.name === 'Tutorials') {
                    setTutorialsRef(elem);
                  }
                  // if (elem && item.isChild && item?.hoverChildMenu?.length > 0) {
                  //   childMenuref = childMenuref?.slice() || [];
                  //   childMenuref[i] = elem;
                  // }
                }}
                {...(tooltip && {
                  onBlur: hideTooltip,
                  onClick: hideTooltip,
                })}
                // onMouseLeave={() => setSelectMenu(null)}
                // onMouseEnter={() => setSelectMenu(item)}
                className={cx(
                  {
                    active:
                      (location.pathname === COMMON_HOME ||
                        location.pathname === ADMIN_HOME_PATH) &&
                      item.path === ADMIN_DASHBOARD
                        ? true
                        : item?.hoverChildMenu && item?.hoverChildMenu?.length
                        ? item?.hoverChildMenu.some(({ path }) =>
                            location.pathname === path ? true : handleDetailsPageRoute(item)
                          )
                        : item?.path?.includes(SETTINGS_ROUTE) && location.search
                        ? item?.path?.includes(location.search) ||
                          location.pathname.includes(item.path?.replace(window.location.search, ''))
                        : location.pathname.includes(
                            item.path?.replace(window.location.search, '')
                          ),
                    hightlightOnboarding: item.name === 'Tutorials' && tooltip,
                  },
                  menuItemClassName
                )}>
                {item.path && !item?.newTab && (
                  <Link
                    to={item.path}
                    className="nav-link"
                    target={target}
                    onMouseOver={(e) => handleMouseHover(e, item, true)}
                    onMouseLeave={(e) => handleMouseHover(e, item, false)}
                    onClick={() => {
                      // clearing uploaded files on menu click as UploadFileProgressModal is common to the app
                      // and is causing conflict in flow of dashboard upload and model upload
                      dispatch(setUploadedFiles({}));
                      Mixpanel.track(true, item.mx_event, menuClickProps(item));
                      window.$restrictFilter = null;
                      setShowHoverComponent(false);
                    }}>
                    {Icon && <Icon />}
                    <span className={item?.isNew ? 'w-auto' : ''}>{item.name}</span>
                    {item?.isNew ? <div className="new-tag">NEW</div> : null}
                    {item?.hoverComponent ? (
                      <item.hoverComponent
                        show={showHoverComponent}
                        setShow={setShowHoverComponent}
                      />
                    ) : null}
                     {LottieIcon &&
                    <div className={styles.lottieIcon}>
                      <Lottie
                        animationData={LottieIcon}
                        loop
                        autoplay
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div>
                  }
                  </Link>
                )}

                {(!item?.path || item?.newTab) && (
                  <a
                    className="nav-link feedback-menu"
                    {...(item?.newTab && {
                      target: '_blank',
                      href: item?.path,
                    })}
                    onClick={async () => {
                      window.$restrictFilter = null;
                      Mixpanel.track(true, item.mx_event, menuClickProps(item));
                      if (item.key === MENU_TYPE.FEEDBACK) {
                        dispatch(setFeedbackDialogOpen(true));
                      }
                      if (item.key === MENU_TYPE.CONTACT_SUPPORT_FORM) {
                        dispatch(setContactSupportFormOpen(true));
                      }
                      if (item.key === MENU_TYPE.LOGOUT) {
                        await handleLogout();
                      }
                      if (item.key === 'JOIN_DISCORD') {
                        window.open(IMAGINE_DISCORD_CHANNEL, '_blank');
                      }
                      if (item.key === 'JOIN_INSTAGRAM') {
                        window.open(IMAGINE_INSTAGRAM_CHANNEL, '_blank');
                      }
                    }}>
                    {Icon && <Icon />}
                    <span>{item.name}</span>
                     {LottieIcon &&
                    <div className={styles.lottieIcon}>
                      <Lottie
                        animationData={LottieIcon}
                        loop
                        autoplay
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div>
                  }
                  </a>
                )}
                {/* {item?.isChild && item?.hoverChildMenu?.length > 0 && (
                  <>
                    {childMenuref[i] && selectMenu?.name === item?.name && (
                      <Overlay
                        target={childMenuref[i]}
                        container={document.body}
                        show={true}
                        placement="right-start">
                        {({ ...props }) => (
                          <Tooltip
                            {...props}
                            className="side-dropdown-menu"
                            style={{
                              width: '279px',
                              ...props.style,
                            }}>
                            <Nav
                              as="ul"
                              className="side-dropdown-menu"
                              onMouseEnter={() => setSelectMenu(item)}>
                              {item?.hoverChildMenu?.map((childList, idx) => {
                                const ChildIcon = childList?.icon;
                                const childTarget = childList?.target || '_self';
                                return (
                                  <Nav.Item
                                    className={cx({
                                      active: location.pathname === childList.path,
                                    })}>
                                    {childList.path && (
                                      <Link
                                        to={childList.path}
                                        className="nav-link"
                                        target={childTarget}
                                        onClick={() => {
                                          setSelectMenu(null);
                                          Mixpanel.track(true, childList.mx_event);
                                        }}>
                                        {ChildIcon && <ChildIcon />}
                                        <span>{childList.name}</span>
                                      </Link>
                                    )}
                                  </Nav.Item>
                                );
                              })}
                            </Nav>
                          </Tooltip>
                        )}
                      </Overlay>
                    )}
                  </>
                )} */}
              </Nav.Item>
            );
          })}
          {isGuestLogin && showBtn && (
            <Nav.Item as="li" onClick={handleShowModal}>
              <div className="sign-up-btn">Sign up</div>
            </Nav.Item>
          )}
        </Nav>
      </Navbar>
      {tutorialsRef && tooltip && (
        <Overlay target={tutorialsRef} container={document.body} show={true} placement="right">
          {({ ...props }) => (
            <Tooltip
              {...props}
              className="customTooltip customTooltipLeftSpacing"
              style={{
                width: '279px',
                ...props.style,
              }}>
              <div className="d-flex justify-content-start align-items-center">
                <div className="customTooltipTitle">Onboarding & Tutorials</div>
                <div className="customTooltipIcon">
                  <img src={Close} title="Tutorials" onClick={hideTooltip} />
                </div>
              </div>
              <div className="customTooltipText">
                Checkout onboarding & tutorials to help you learn all about imagine.io.
              </div>
            </Tooltip>
          )}
        </Overlay>
      )}
    </>
  );
}
